import { render, staticRenderFns } from "./dataProofreading.vue?vue&type=template&id=85b36414&scoped=true&"
import script from "./dataProofreading.vue?vue&type=script&lang=js&"
export * from "./dataProofreading.vue?vue&type=script&lang=js&"
import style0 from "./dataProofreading.vue?vue&type=style&index=0&id=85b36414&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b36414",
  null
  
)

export default component.exports